/* Rising Sun FPV - FPV build checker.
   Section: sections/rs-fpv-checker.liquid   Styles: assets/rs-fpv-checker.css
   Vanilla JS, no libraries, no network requests, nothing stored.
   Every threshold, table and shop link is in CONFIG. Change the numbers there;
   the code below only reads them. Where the figures come from: README.md. */
(function () {
'use strict';

/* ==== CONFIG - edit this to tune the checker ====
   States: 'ok' = green OK, 'warn' = amber Check, 'bad' = red Problem. */
var CONFIG = {

  /* ---- Where amber turns into red ---- */
  kvTolerance: 0.15,     // KV up to 15% outside the typical range = amber, further = red
  escNearFactor: 0.75,   // ESC amps at 75% or more of the class minimum = amber, lower = red
  frameOversize: 1.3,    // frame made for props 30% bigger (or more) than yours = amber
  kvSane: [100, 80000],  // KV outside this is treated as a typo
  escSane: [1, 250],     // ESC amps outside this are treated as a typo

  /* ---- Build classes, smallest to largest ----
     name    how the class reads in sentences. pname (prop size) and a (with "a" or
             "an") default to name and "a " + name, so set them only when different.
     prop    prop diameter in inches [smallest, largest]. duct: true = whoop ducts.
     stator  ok = [smallest, largest] stator that suits (green). near = a little
             outside (amber). Outside near = red. Compared by stator volume, so
             2207 vs 2306 works out. text = the typical sizes we quote.
     kv      typical KV per cell count { cells: [low, high] }. No entry = unusual pack.
     esc     min = continuous amps per motor for green. text = what most builds run.
     pack    typical pack capacity in mAh { cells: [low, high] } (information only).
     cells   usual packs, quoted when the chosen cell count isn't typical.
     liion   optional Li-ion note for the battery guide (3S and up).
     props / frames / motors  collection keys (see collections) for the shop links. */
  classes: [
    { id: 'w31', name: '65 mm whoop', pname: '31 mm', prop: [1.2, 1.2], duct: true,
      stator: { ok: ['0602', '0803'], near: ['0502', '1002'], text: '0702 to 0802' },
      kv: { 1: [18000, 30000], 2: [10000, 14000] },
      esc: { min: 5, text: '5 to 12 A' },
      pack: { 1: [250, 450], 2: [300, 450] },
      cells: '1S (a few run 2S)',
      props: ['propsW'], frames: ['framesW'], motors: ['m07', 'm08'] },
    { id: 'w40', name: '75 mm whoop', pname: '40 mm', prop: [1.6, 1.6], duct: true,
      stator: { ok: ['0802', '1103'], near: ['0702', '1104'], text: '0802 to 1103' },
      kv: { 1: [15000, 23000], 2: [10000, 16000], 3: [8000, 11000] },
      esc: { min: 5, text: '5 to 15 A' },
      pack: { 1: [300, 550], 2: [300, 450], 3: [300, 450] },
      cells: '1S or 2S',
      props: ['propsW'], frames: ['framesW'], motors: ['m08', 'm07', 'motors'] },
    { id: 'p2', name: '2 inch', prop: [2, 2],
      stator: { ok: ['1002', '1106'], near: ['0802', '1404'], text: '1103 to 1105' },
      kv: { 1: [15000, 20000], 2: [6000, 14000], 3: [5500, 8000], 4: [4500, 6000] },
      esc: { min: 12, text: '12 to 20 A' },
      pack: { 1: [450, 650], 2: [300, 550], 3: [300, 550], 4: [450, 650] },
      cells: '2S or 3S',
      props: ['props2'], frames: ['frames2'], motors: ['m12', 'motors'] },
    { id: 'p25', name: '2.5 inch', prop: [2.5, 2.5],
      stator: { ok: ['1102', '1404'], near: ['1002', '1407'], text: '1103 to 1404' },
      kv: { 2: [5000, 10000], 3: [4500, 8000], 4: [4000, 5200] },
      esc: { min: 15, text: '15 to 25 A' },
      pack: { 2: [300, 650], 3: [450, 650], 4: [450, 850] },
      cells: '3S or 4S',
      props: ['props2'], frames: ['frames2', 'frames3'], motors: ['m14', 'm12'] },
    { id: 'p3', name: '3 inch', prop: [3, 3],
      stator: { ok: ['1203', '1608'], near: ['1103', '2205'], text: '1204 to 1507' },
      kv: { 2: [6000, 10000], 3: [4500, 6500], 4: [3500, 5000], 6: [2400, 3200] },
      esc: { min: 20, text: '20 to 35 A' },
      pack: { 2: [450, 850], 3: [450, 850], 4: [550, 1100], 6: [450, 850] },
      cells: '4S (3S to 6S)',
      props: ['props3'], frames: ['frames3'], motors: ['m14', 'm15'] },
    { id: 'p35', name: '3.5 inch', prop: [3.5, 3.5],
      stator: { ok: ['1404', '2004'], near: ['1303', '2205'], text: '1404 to 2004' },
      kv: { 4: [3000, 4300], 6: [2000, 3100] },
      esc: { min: 25, text: '25 to 40 A' },
      pack: { 4: [650, 1100], 6: [550, 850] },
      cells: '4S or 6S',
      props: ['props3'], frames: ['frames3'], motors: ['m14', 'm15', 'm20'] },
    { id: 'p4', name: '4 inch', prop: [4, 4],
      stator: { ok: ['1404', '2106'], near: ['1303', '2207'], text: '1404 to 2004' },
      kv: { 3: [3500, 4500], 4: [2400, 3800], 6: [1700, 2800] },
      esc: { min: 30, text: '30 to 45 A' },
      pack: { 3: [650, 850], 4: [850, 1300], 6: [650, 1000] },
      cells: '4S or 6S',
      liion: 'Long range 4 inch builds often carry a 2500 to 3000 mAh Li-ion pack.',
      props: ['props4'], frames: ['frames4'], motors: ['m20', 'm15'] },
    { id: 'p5', name: '5 inch', prop: [5, 5.1],
      stator: { ok: ['2205', '2308'], near: ['2004', '2408'], text: '2207 to 2306' },
      kv: { 4: [2000, 2800], 5: [1750, 2400], 6: [1600, 2100] },
      esc: { min: 40, text: '45 to 60 A' },
      pack: { 4: [1300, 1800], 5: [1100, 1500], 6: [1000, 1400] },
      cells: '6S (or 4S)',
      props: ['props5', 'props51'], frames: ['frames5'], motors: ['m22', 'm23'] },
    { id: 'p6', name: '6 inch', prop: [6, 6],
      stator: { ok: ['2306', '2408'], near: ['2205', '2806.5'], text: '2306 to 2507' },
      kv: { 4: [1700, 2500], 5: [1500, 2000], 6: [1300, 1800] },
      esc: { min: 40, text: '45 to 60 A' },
      pack: { 4: [1500, 2200], 5: [1300, 1800], 6: [1100, 1800] },
      cells: '6S (or 4S)',
      props: ['props6'], frames: ['frames6'], motors: ['m23', 'm24', 'm25'] },
    { id: 'p7', name: '7 inch', prop: [7, 7],
      stator: { ok: ['2507', '2810'], near: ['2306', '3110'], text: '2507 to 2808' },
      kv: { 4: [1300, 1900], 5: [1100, 1600], 6: [1000, 1500] },
      esc: { min: 45, text: '50 to 65 A' },
      pack: { 4: [1800, 2600], 5: [1500, 2200], 6: [1300, 2200] },
      cells: '6S (or 4S)',
      liion: 'Long range 7 inch builds often run 3000 to 4500 mAh Li-ion packs.',
      props: ['props7'], frames: ['frames7'], motors: ['m28', 'm25'] },
    { id: 'p8', name: '8 to 10 inch', a: 'an 8 to 10 inch', prop: [8, 10],
      stator: { ok: ['2808', '3115'], near: ['2806', '3120'], text: '2808 to 3115' },
      kv: { 4: [900, 1700], 6: [650, 1300], 8: [450, 1000] },
      esc: { min: 60, text: '60 to 80 A' },
      pack: { 4: [2600, 5000], 6: [2200, 5000], 8: [1800, 3300] },
      cells: '6S (some run 8S)',
      liion: 'Long range rigs this size often run 4000 to 8400 mAh Li-ion packs.',
      props: ['props8'], frames: ['frames8', 'frames9', 'frames10'], motors: ['m28', 'motors'] }
  ],

  /* ---- Frame "max prop size" options: inch = biggest prop it takes, duct = whoop frame ---- */
  frames: {
    '1.2': { inch: 1.2, duct: true, name: '31 mm' }, '1.6': { inch: 1.6, duct: true, name: '40 mm' },
    '2': { inch: 2, name: '2 inch' }, '2.5': { inch: 2.5, name: '2.5 inch' }, '3': { inch: 3, name: '3 inch' },
    '3.5': { inch: 3.5, name: '3.5 inch' }, '4': { inch: 4, name: '4 inch' }, '5': { inch: 5.1, name: '5 inch' },
    '6': { inch: 6, name: '6 inch' }, '7': { inch: 7, name: '7 inch' }, '8': { inch: 8, name: '8 inch' },
    '9': { inch: 9, name: '9 inch' }, '10': { inch: 10, name: '10 inch' }
  },

  /* ---- Battery connectors ----
     Each rule row gives a reason code per connector in this order: PH2.0 BT2.0 XT30 XT60.
     c1 = 1S packs, c2 = 2S, c3 = 3S and up, all = any cell count. */
  connectors: ['ph20', 'bt20', 'xt30', 'xt60'],
  connectorNames: { ph20: 'PH2.0', bt20: 'BT2.0', xt30: 'XT30', xt60: 'XT60' },
  connectorRules: {
    w31: { c1: 'tipbt ok heavy big', c2: 'single series ok big', c3: 'single single ok big' },
    w40: { c1: 'tipbt ok heavy big', c2: 'single series ok big', c3: 'single single ok big' },
    p2: { c1: 'sag ok ok heavy', c2: 'single series ok heavy', c3: 'single single ok heavy' },
    p25: { all: 'small small ok heavy' },
    p3: { all: 'small small ok heavy' },
    p35: { all: 'small small limit ok' },
    p4: { all: 'small small limit ok' },
    p5: { all: 'small small small ok' },
    p6: { all: 'small small small ok' },
    p7: { all: 'small small small ok' },
    p8: { all: 'small small small ok' }
  },
  /* Reason codes: [state, text]. {conn} connector, {a} build class, {n} cells, {usual} the green options. */
  connectorReasons: {
    ok: ['ok', '{conn} is the usual plug for {a}.'],
    tipbt: ['ok', 'PH2.0 works on 1S whoops. BT2.0 has bigger contacts and sags less, so you get more punch.'],
    heavy: ['warn', "{conn} works, but it's heavier than {a} needs. Most use {usual}."],
    big: ['bad', '{conn} is far too big and heavy for a whoop. Use {usual}.'],
    single: ['bad', '{conn} is a 1S plug. A {n}S pack needs {usual}.'],
    series: ['warn', 'BT2.0 is a 1S plug. Some 2S whoops run two 1S packs in series with an adapter. Otherwise use XT30.'],
    sag: ['warn', 'PH2.0 sags a lot at 2 inch current draw. BT2.0 or XT30 gives more punch.'],
    small: ['bad', "{conn} can't carry the current {a} pulls. It will get hot and the voltage will sag. Use {usual}."],
    limit: ['warn', '{conn} is near its limit on {a}. It suits light builds, but {usual} is the safer pick.']
  },

  /* ---- Video: rules for "quad|goggles" pairs, [state, reason] ----
     Checked against DJI, HDZero and Walksnail info in October 2026 (see README).
     Pairs not listed: a DJI air unit with other goggles gets videoDjiAir, and other
     systems into DJI goggles get videoDjiGoggles ({vtx} from videoNames). Both are red. */
  video: {
    'analog|analog': ['ok', 'Analog to analog works. Set both to the same band and channel. This assumes 5.8 GHz; 1.2, 1.3 or 3.3 GHz needs a matching receiver.'],
    'analog|hdz': ['warn', 'HDZero Goggle 2 and BoxPro have analog built in. The original HDZero Goggle needs an analog module in its side bay.'],
    'analog|ws': ['warn', 'Goggles X shows analog through its AV-in port with an external 5.8 GHz receiver. The original Avatar goggles have no analog input.'],
    'hdz|hdz': ['ok', 'HDZero to HDZero works. Keep VTX and goggle firmware up to date.'],
    'hdz|analog': ['warn', "Not out of the box. Analog goggles can't decode HDZero. Only goggles with HDMI in can show it, through an HDZero receiver (VRX)."],
    'hdz|ws': ['warn', "Not out of the box. Walksnail goggles can't decode HDZero, but Goggles X has HDMI in for an HDZero receiver (VRX)."],
    'ws|ws': ['ok', 'Walksnail to Walksnail works. Keep the VTX and goggles on matching firmware.'],
    'ws|analog': ['warn', "Not out of the box. Analog goggles can't decode Walksnail. Only goggles with HDMI in can show it, through the Walksnail Avatar VRX."],
    'ws|hdz': ['warn', "HDZero goggles can't decode Walksnail on their own. The Walksnail Avatar VRX can feed their HDMI input."],
    'o3|g2': ['ok', 'The O3 works with Goggles 2.'],
    'o3|gi': ['ok', 'The O3 works with Goggles Integra.'],
    'o3|g3': ['warn', 'Works after a firmware update: Goggles 3 v01.00.0300 or later and O3 v01.03.0000 or later. Update both before binding. A DJI remote must be the FPV Remote Controller 3.'],
    'o3|n3': ['bad', "DJI has confirmed Goggles N3 doesn't support the O3. Pair N3 with an O4 Air Unit."],
    'o4|g2': ['warn', 'DJI supports this on current firmware. Update the goggles and air unit first. Race mode needs Goggles 3 or N3.'],
    'o4|gi': ['warn', 'DJI supports this on current firmware. Update the goggles and air unit first. Race mode needs Goggles 3 or N3.'],
    'o4|g3': ['ok', 'The O4 works with Goggles 3, including Race mode.'],
    'o4|n3': ['ok', 'The O4 works with Goggles N3, including Race mode.']
  },
  djiAirUnits: ['o3', 'o4'],
  djiGoggles: ['g2', 'gi', 'g3', 'n3'],
  videoNames: { analog: 'analog video', hdz: 'HDZero', ws: 'Walksnail' },
  videoDjiAir: "DJI air units only work with DJI goggles. Third-party goggles aren't supported.",
  videoDjiGoggles: "DJI goggles only receive DJI air units. They can't show {vtx}.",

  /* ---- Radio link: rules for "module|receiver" pairs, [state, reason] ----
     Pairs not listed are red with rcOther ({tx} and {rx} come from rcNames). */
  rc: {
    'elrs24|elrs24': ['ok', 'Both ExpressLRS 2.4 GHz. Use the same major version (both 3.x, say) and binding phrase.'],
    'elrs24|elrsdual': ['ok', 'The dual band receiver links on 2.4 GHz. Use the same major version and binding phrase.'],
    'elrs24|elrs900': ['bad', "Different bands. A 2.4 GHz module can't talk to a 900 MHz receiver."],
    'elrs900|elrs900': ['ok', 'Both ExpressLRS 900 MHz. Use the same major version and binding phrase, and the AU915 domain in Australia.'],
    'elrs900|elrsdual': ['ok', 'The dual band receiver links on 900 MHz. Use the same major version, binding phrase and AU915 domain.'],
    'elrs900|elrs24': ['bad', "Different bands. A 900 MHz module can't talk to a 2.4 GHz receiver."],
    'elrs900|crsf': ['bad', "Same band, different system. ExpressLRS and Crossfire don't talk to each other."],
    'elrsdual|elrsdual': ['ok', 'Both dual band ExpressLRS. Use the same major version and binding phrase.'],
    'elrsdual|elrs24': ['warn', "Works if you pick a 2.4 GHz packet rate. In a dual band (Gemini X) mode the receiver won't sync."],
    'elrsdual|elrs900': ['warn', "Works if you pick a 900 MHz packet rate and the AU915 domain. In a dual band (Gemini X) mode the receiver won't sync."],
    'crsf|crsf': ['ok', 'Crossfire to Crossfire works.'],
    'crsf|elrs900': ['bad', "Same band, different system. Crossfire and ExpressLRS don't talk to each other."],
    'tracer|tracer': ['ok', 'Tracer to Tracer works.'],
    'frsky|frsky': ['warn', 'Should work if the receiver matches the module on protocol (D8, D16 or ACCESS), ACCST V1 or V2 firmware, and EU or FCC version.'],
    'flysky|flysky': ['warn', "Should work if both use the same FlySky protocol. AFHDS 2A and AFHDS 3 don't mix."],
    'multi|frsky': ['warn', 'A 4-in-1 module binds FrSky D8 and D16 (ACCST V1 or V2) receivers, not ACCESS. Pick the matching protocol on the radio.'],
    'multi|flysky': ['warn', 'A 4-in-1 module binds FlySky AFHDS and AFHDS 2A receivers, not AFHDS 3.']
  },
  rcNames: { elrs24: 'ExpressLRS 2.4 GHz', elrs900: 'ExpressLRS 900 MHz', elrsdual: 'Dual band ExpressLRS', crsf: 'Crossfire', tracer: 'Tracer', frsky: 'FrSky', flysky: 'FlySky', multi: '4-in-1 multi-protocol' },
  rcOther: "{tx} modules can't bind to {rx} receivers. Pick a receiver that matches the radio.",

  /* ---- Store collections for "Shop matching parts": key: [handle, link text] ----
     All checked in October 2026: they exist, are on the Online Store and have active
     products. "receviers" really is spelt that way in the store. */
  collections: {
    motors: ['motors', 'All motors'],
    m07: ['07xx', '07xx motors'], m08: ['08xx', '08xx motors'], m12: ['12xx', '12xx motors'],
    m14: ['14xx', '14xx motors'], m15: ['15xx', '15xx motors'], m20: ['20xx', '20xx motors'],
    m22: ['22xx', '22xx motors'], m23: ['23xx', '23xx motors'], m24: ['24xx', '24xx motors'],
    m25: ['25xx', '25xx motors'], m28: ['28xx', '28xx motors'],
    propsW: ['tinywhoop-props', 'Whoop props'], props2: ['2-props', '2 and 2.5 inch props'],
    props3: ['3-props', '3 and 3.5 inch props'], props4: ['4-props', '4 inch props'],
    props5: ['5-props', '5 inch props'], props51: ['5-1-props', '5.1 inch props'],
    props6: ['6-props', '6 inch props'], props7: ['7-props', '7 inch props'],
    props8: ['8-13-props', '8 to 13 inch props'],
    framesW: ['tinywhoop', 'Whoop frames'], frames2: ['2', '2 inch frames'], frames3: ['3-1', '3 inch frames'],
    frames4: ['3', '4 inch frames'], frames5: ['5-inch-frames', '5 inch frames'], frames6: ['6-inch-frames', '6 inch frames'],
    frames7: ['7-inch-frames', '7 inch frames'], frames8: ['8-inch-frames', '8 inch frames'],
    frames9: ['9-inch-frames', '9 inch frames'], frames10: ['10-inch-frames', '10 inch frames'],
    stacks: ['stacks', 'Stacks and AIOs'], esc4: ['4in1-esc', '4-in-1 ESCs'], escs: ['escs', 'ESCs'],
    fc: ['fc', 'Flight controllers'], caps: ['capacitors', 'Capacitors'], conns: ['connectors', 'Connectors'],
    lipos: ['lipos', 'LiPos'], lipo1: ['1s-lipos', '1S LiPos'], lipo2: ['2s-lipos', '2S LiPos'],
    lipo3: ['3s-lipos', '3S LiPos'], lipo4: ['4s-lipos', '4S LiPos'], lipo6: ['6s-lipos', '6S LiPos'],
    liion: ['li-ion', 'Li-ion packs'], chargers: ['chargers', 'Chargers'],
    vtx: ['vtx', 'VTXs and air units'], cams: ['fpv-cams', 'FPV cameras'], hdzero: ['hdzero', 'HDZero gear'],
    goggles: ['fpv-goggles', 'FPV goggles'], vrx: ['vrx', 'Goggle receiver modules'],
    rx: ['receviers', 'Receivers'], radios: ['radios', 'Radios'], txmods: ['rc-link-accessories', 'TX modules and RC gear']
  },

  /* ---- Which collections each check links to (keys from collections) ---- */
  links: {
    escAmps: ['stacks', 'esc4'],
    escAmpsSmall: ['stacks'],          // whoops and 2 inch run AIO boards
    escVolts: ['stacks', 'escs', 'fc'],
    capacitor: 'caps',                 // added when the pack is at the top of the ESC range
    mount: ['stacks', 'fc'],
    connector: ['conns'],
    lipoByCells: { 1: 'lipo1', 2: 'lipo2', 3: 'lipo3', 4: 'lipo4', 6: 'lipo6' },
    lipoOther: 'lipos',
    liion: 'liion',
    chargers: 'chargers',
    video: { analog: ['vtx', 'cams'], hdz: ['hdzero'], ws: ['vtx', 'cams'], o3: ['vtx'], o4: ['vtx'] },
    goggles: 'goggles',
    gogglesModule: 'vrx',              // added for analog into HDZero or Walksnail goggles
    rc: ['rx', 'radios', 'txmods']
  }
};
/* ==== end of CONFIG ==== */

var d = document;
var LABEL = { ok: 'OK', warn: 'Check', bad: 'Problem', info: 'Info', idle: 'Waiting' };
var NEED = {
  cls: 'build class', fmax: 'frame max prop size', fmount: 'frame stack mounts',
  stator: 'motor stator size', kv: 'motor KV', cells: 'battery cells', conn: 'battery connector',
  esca: 'ESC current rating', escv: 'ESC/FC cell range', stack: 'stack mount pattern',
  vtx: 'video system on the quad', gog: 'goggles', rx: 'receiver protocol', tx: 'radio module'
};
var ERR = {
  stator: 'Use the 4-digit stator size, like 2207 or 2806.5.',
  kv: 'That KV looks off. Enter a number like 1900.',
  esca: 'That rating looks off. Enter the amps per motor, like 45.'
};

/* ---- helpers ---- */
function $(s, r) { return r.querySelector(s); }
function $$(s, r) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }
function fmt(n) { return Number(n).toLocaleString('en-AU', { maximumFractionDigits: 1 }); }
function pad2(n) { return (n < 10 ? '0' : '') + n; }
function res(state, text, links) { return { state: state, text: text, links: links || [] }; }
function pat(mm) { return mm + 'x' + mm; }
function list(a) { return a.length > 1 ? a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1] : a[0]; }
function findClass(id) {
  for (var i = 0, c; (c = CONFIG.classes[i]); i++) {
    if (c.id === id) { c.idx = i; c.pname = c.pname || c.name; c.a = c.a || 'a ' + c.name; return c; }
  }
  return null;
}
function lipoKey(n) { return CONFIG.links.lipoByCells[n] || CONFIG.links.lipoOther; }

/* Stator like 2207, 2207.5, 0802 or 22x07: width, height and volume (mm3). */
function parseStator(raw) {
  var s = String(raw || '').replace(/,/g, '.'), m;
  if (!(m = s.match(/(\d{1,2})\s*[x×*]\s*(\d{1,2}(?:\.\d+)?)/i) || s.match(/(\d{2})(\d{2}(?:\.\d+)?)/))) return null;
  var w = +m[1], h = +m[2], hs = String(h).split('.');
  if (w < 3 || w > 60 || h < 1 || h > 40) return null;
  return { label: pad2(w) + pad2(+hs[0]) + (hs[1] ? '.' + hs[1] : ''), vol: Math.PI / 4 * w * w * h };
}
function statorBounds(c) {
  if (!c._b) {
    var v = function (code) { return parseStator(code).vol; };
    c._b = [v(c.stator.near[0]), v(c.stator.ok[0]), v(c.stator.ok[1]), v(c.stator.near[1])];
  }
  return c._b;
}
function parseNumber(raw, sane) {
  var s = String(raw || '').replace(/[,\s]/g, ''), m = s.match(/\d+(?:\.\d+)?/), n = m ? parseFloat(m[0]) : NaN;
  if (!s) return {};
  return isFinite(n) && n >= sane[0] && n <= sane[1] ? { value: n } : { error: true };
}

/* ---- the checks ----
   Each gets the parsed form (v) and returns res(state, text, linkKeys). */
function checkProp(v) {
  var c = v.cls, f = v.fmax, P = c.pname + ' props', L = c.props.concat(c.frames), ratio;
  if (c.duct && f.duct) {
    if (c.prop[1] === f.inch) return res('ok', P + " suit this frame's ducts.", L);
    if (c.prop[1] > f.inch) return res('bad', "40 mm props won't fit 31 mm ducts. Use 31 mm props, or a 75 mm whoop frame.", L);
    return res('warn', '31 mm props in 40 mm ducts leave a big gap and lose thrust. Use 40 mm props.', L);
  }
  if (f.duct) return res('bad', P + " won't fit a whoop frame. Its ducts only take " + f.name + ' props.', L);
  if (c.duct) return res('warn', 'Whoop props will fit, but a ' + f.name + ' frame is far bigger than they need. Expect a heavy, sluggish quad.', L);
  if (c.prop[0] > f.inch) return res('bad', P + ' are too big for this frame, which takes props up to ' + f.name + '. They will hit the arms, the camera or each other.', L);
  if (c.prop[1] > f.inch) return res('warn', 'This frame takes props up to ' + f.name + '. Make sure yours are no bigger.', L);
  ratio = f.inch / c.prop[1];
  if (ratio >= CONFIG.frameOversize) return res('warn', P + ' fit, but this frame is built for ' + f.name + ' props. It will be heavier than it needs to be and feel sluggish.', L);
  return res('ok', P + (ratio > 1.05 ? ' fit, with room to spare.' : ' fit this frame.'), L);
}

function checkStator(v) {
  var c = v.cls, s = v.stator, b = statorBounds(c), n = s.label, a = c.a, most = ' Most use ' + c.stator.text + '.';
  if (s.vol >= b[1] && s.vol <= b[2]) return res('ok', n + ' is a typical motor size for ' + a + '.' + most, c.motors);
  if (s.vol < b[1]) {
    if (s.vol >= b[0]) return res('warn', n + ' is on the small side for ' + a + '. It can work on a light build, but expect hot motors and less punch.' + most, c.motors);
    return res('bad', n + ' is too small for ' + a + '. It will struggle to spin the props and overheat.' + most, c.motors);
  }
  if (s.vol <= b[3]) return res('warn', n + ' is bigger than ' + a + ' usually needs. It adds weight and cuts flight time.' + most, c.motors);
  return res('bad', n + ' is far too big for ' + a + '. It is heavy and may not fit the motor mounts.' + most, c.motors);
}

function checkKv(v) {
  var c = v.cls, n = v.cells, kv = v.kv, r = c.kv[n], tol = CONFIG.kvTolerance;
  if (!r) return res('warn', n + "S isn't a usual pack for " + c.a + ", so there's no typical KV to compare. Most run " + c.cells + '.', c.motors);
  var K = fmt(kv) + ' KV', on = ' for ' + n + 'S on ' + c.a + '.', typ = ' Typical is ' + fmt(r[0]) + ' to ' + fmt(r[1]) + ' KV.';
  if (kv >= r[0] && kv <= r[1]) return res('ok', K + ' on ' + n + 'S suits ' + c.a + '.' + typ, c.motors);
  if (kv > r[1]) {
    if (kv <= r[1] * (1 + tol)) return res('warn', K + ' is a little high' + on + ' Expect hotter motors and more strain on the ESC.' + typ, c.motors);
    return res('bad', K + ' is far too high' + on + ' Motors and ESC will run very hot and may burn out.' + typ, c.motors);
  }
  if (kv >= r[0] * (1 - tol)) return res('warn', K + ' is a little low' + on + ' It will feel soft and less punchy.' + typ, c.motors);
  return res('bad', K + ' is far too low' + on + ' It will feel sluggish and may struggle to hover.' + typ, c.motors);
}

function checkEscAmps(v) {
  var c = v.cls, A = fmt(v.esca) + ' A', min = c.esc.min, most = ' Most run ' + c.esc.text + '.';
  var L = c.idx <= 2 ? CONFIG.links.escAmpsSmall : CONFIG.links.escAmps;
  if (v.esca >= min) return res('ok', A + ' per motor is enough for ' + c.a + '.' + most, L);
  if (v.esca >= min * CONFIG.escNearFactor) return res('warn', A + ' is on the low side for ' + c.a + '. Fine for gentle flying, but hard punch-outs can overheat it.' + most, L);
  return res('bad', A + ' is too low for ' + c.a + ' and likely to overheat or burn out. Look for at least ' + min + ' A.', L);
}

function checkEscVolts(v) {
  var n = v.cells, r = v.escv, L = CONFIG.links.escVolts.slice(), t;
  if (n > r.max) return res('bad', n + 'S is over the ' + r.label + ' rating. It will likely burn out the ESC or flight controller.', L);
  if (n < r.min) return res('bad', n + 'S is under the ' + r.label + ' rating. The flight controller may not power up, or may brown out in flight.', L);
  t = n + 'S is within the ' + r.label + ' rating.';
  if (n === r.max && n >= 4) { t += ' At the top of the range, fit a low-ESR capacitor to soak up voltage spikes.'; L.push(CONFIG.links.capacitor); }
  return res('ok', t, L);
}

function checkMount(v) {
  var s = v.stack, names = list(v.fmount.map(pat)), L = CONFIG.links.mount.concat(v.cls ? [v.cls.frames[0]] : []);
  if (v.fmount.indexOf(s) > -1) return res('ok', 'A ' + pat(s) + ' stack bolts straight onto the frame.', L);
  if (v.fmount.some(function (x) { return x > s; })) return res('warn', 'The frame takes ' + names + '. A ' + pat(s) + ' stack needs an adapter plate, so check one is made for your frame.', L);
  return res('bad', 'A ' + pat(s) + ' stack is too big for this frame, which takes ' + names + '.', L);
}

function checkConn(v) {
  var c = v.cls, rules = CONFIG.connectorRules[c.id], keys = CONFIG.connectors, i = keys.indexOf(v.conn), row = rules.all;
  if (!row && v.cells) row = rules[v.cells === 1 ? 'c1' : v.cells === 2 ? 'c2' : 'c3'];
  if (!row) {
    /* Cells only matter when the code differs between pack sizes. */
    var codes = ['c1', 'c2', 'c3'].map(function (g) { return rules[g].split(/\s+/)[i]; });
    if (codes[0] !== codes[1] || codes[1] !== codes[2]) return { state: 'idle', need: ['cells'] };
    row = rules.c1;
  }
  var codesRow = row.split(/\s+/), reason = CONFIG.connectorReasons[codesRow[i]];
  var usual = keys.filter(function (k, j) { return codesRow[j] === 'ok'; }).map(function (k) { return CONFIG.connectorNames[k]; });
  var text = reason[1].replace('{conn}', CONFIG.connectorNames[v.conn]).replace('{a}', c.a).replace('{n}', v.cells).replace('{usual}', usual.join(' or '));
  return res(reason[0], text, CONFIG.links.connector.concat(v.cells ? [lipoKey(v.cells)] : []));
}

function checkVideo(v) {
  var r = CONFIG.video[v.vtx + '|' + v.gog], L = (CONFIG.links.video[v.vtx] || []).slice();
  if (!r && CONFIG.djiAirUnits.indexOf(v.vtx) > -1) r = ['bad', CONFIG.videoDjiAir];
  if (!r && CONFIG.djiGoggles.indexOf(v.gog) > -1) r = ['bad', CONFIG.videoDjiGoggles.replace('{vtx}', CONFIG.videoNames[v.vtx] || 'it')];
  if (!r) r = ['warn', "We don't have a rule for this pair yet. Ask us before you buy."];
  if (v.vtx === 'analog' && (v.gog === 'hdz' || v.gog === 'ws')) L.push(CONFIG.links.gogglesModule);
  L.push(CONFIG.links.goggles);
  return res(r[0], r[1], L);
}

function checkRc(v) {
  var r = CONFIG.rc[v.tx + '|' + v.rx];
  return r ? res(r[0], r[1], CONFIG.links.rc)
    : res('bad', CONFIG.rcOther.replace('{tx}', CONFIG.rcNames[v.tx]).replace('{rx}', CONFIG.rcNames[v.rx]), CONFIG.links.rc);
}

function checkPack(v) {
  var c = v.cls, n = v.cells, r = c.pack[n], li = c.liion && n >= 3, L = [lipoKey(n)].concat(li ? [CONFIG.links.liion] : [], [CONFIG.links.chargers]);
  if (!r) return res('warn', n + "S isn't a usual pack for " + c.a + '. Most run ' + c.cells + '.', L);
  return res('info', 'Most ' + c.name + ' builds on ' + n + 'S run about ' + fmt(r[0]) + ' to ' + fmt(r[1]) + ' mAh. Bigger packs fly longer but add weight.' + (li ? ' ' + c.liion : ''), L);
}

/* Same order as the rows in the section. needs = fields that must be filled first. */
var CHECKS = {
  prop: { needs: ['cls', 'fmax'], run: checkProp },
  stator: { needs: ['cls', 'stator'], run: checkStator },
  kv: { needs: ['cls', 'kv', 'cells'], run: checkKv },
  esca: { needs: ['cls', 'esca'], run: checkEscAmps },
  escv: { needs: ['cells', 'escv'], run: checkEscVolts },
  mount: { needs: ['fmount', 'stack'], run: checkMount },
  conn: { needs: ['cls', 'conn'], run: checkConn },
  video: { needs: ['vtx', 'gog'], run: checkVideo },
  rc: { needs: ['rx', 'tx'], run: checkRc },
  pack: { needs: ['cls', 'cells'], run: checkPack }
};

function evaluate(id, v) {
  var miss = CHECKS[id].needs.filter(function (k) { return !v[k]; });
  var out = miss.length ? { state: 'idle', need: miss } : CHECKS[id].run(v);
  if (out.state === 'idle') out.text = 'Needs: ' + out.need.map(function (k) { return NEED[k]; }).join(', ') + '.';
  return out;
}

/* ---- one checker on the page ---- */
function Checker(root) {
  var self = this;
  this.root = root;
  this.form = $('[data-rsfc-form]', root);
  this.rows = {};
  $$('[data-check]', root).forEach(function (li) { self.rows[li.getAttribute('data-check')] = li; });
  this.summary = $('[data-rsfc-summary]', root);
  this.live = $('[data-rsfc-live]', root);
  this.status = $('[data-rsfc-status]', root);
  this.copybox = $('[data-rsfc-copybox]', root);
  this.collUrl = (root.getAttribute('data-collections-url') || '/collections').replace(/\/$/, '');
  this.hints = {};
  $$('[data-rsfc-hint]', root).forEach(function (p) { self.hints[p.getAttribute('data-rsfc-hint')] = { el: p, text: p.textContent }; });
  this.results = {};
  this.lastLive = '';
}

Checker.prototype.read = function () {
  var f = this.form.elements, v = { errors: {} };
  function val(name) { return f[name] ? String(f[name].value || '').trim() : ''; }
  v.cls = findClass(val('cls'));
  v.fmax = CONFIG.frames[val('fmax')] || null;
  v.fmount = $$('input[name="fmount"]:checked', this.form).map(function (x) { return parseFloat(x.value); });
  if (!v.fmount.length) v.fmount = null;
  v.stator = val('stator') ? parseStator(val('stator')) : null;
  if (val('stator') && !v.stator) v.errors.stator = true;
  var kv = parseNumber(val('kv'), CONFIG.kvSane), ea = parseNumber(val('esca'), CONFIG.escSane);
  v.kv = kv.value || null; v.errors.kv = kv.error;
  v.esca = ea.value || null; v.errors.esca = ea.error;
  v.cells = parseInt(val('cells'), 10) || null;
  v.conn = CONFIG.connectorNames[val('conn')] ? val('conn') : null;
  var ev = val('escv').match(/^(\d+)-(\d+)$/);
  v.escv = ev ? { min: +ev[1], max: +ev[2], label: ev[1] === ev[2] ? ev[1] + 'S' : ev[1] + '-' + ev[2] + 'S' } : null;
  v.stack = parseFloat(val('stack')) || null;
  v.vtx = val('vtx') || null; v.gog = val('gog') || null;
  v.rx = val('rx') || null; v.tx = val('tx') || null;
  return v;
};

/* Errors show when the shopper leaves a field (change) and clear as soon as it's fixed (input). */
Checker.prototype.showErrors = function (v, onlyClear) {
  var self = this;
  Object.keys(this.hints).forEach(function (name) {
    var h = self.hints[name], input = self.form.elements[name], bad = !!v.errors[name];
    if (!input || (bad && onlyClear)) return;
    h.el.textContent = bad ? ERR[name] || h.text : h.text;
    h.el.classList.toggle('is-err', bad);
    if (bad) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
  });
};

Checker.prototype.links = function (keys) {
  var self = this, seen = {};
  return keys.filter(function (k) { var ok = k && !seen[k] && CONFIG.collections[k]; seen[k] = 1; return ok; }).slice(0, 4).map(function (k) {
    var c = CONFIG.collections[k];
    return '<a class="rsfc__pill" href="' + esc(self.collUrl + '/' + c[0]) + '">' + esc(c[1]) + '</a>';
  }).join('');
};

Checker.prototype.title = function (id) {
  var t = this.rows[id] && $('[data-rsfc-title]', this.rows[id]);
  return t ? t.textContent.trim() : id;
};

Checker.prototype.render = function (announce) {
  var self = this, v = this.read(), n = { ok: 0, warn: 0, bad: 0, info: 0 }, run = 0, total = 0, problems = [];
  Object.keys(CHECKS).forEach(function (id) {
    var li = self.rows[id];
    if (!li) return;
    var r = evaluate(id, v), links = r.state === 'idle' ? '' : self.links(r.links), sig = r.state + r.text + links;
    total++;
    self.results[id] = r;
    if (r.state !== 'idle') { run++; n[r.state]++; }
    if (r.state === 'bad') problems.push(self.title(id));
    if (li.getAttribute('data-sig') === sig) return;
    li.setAttribute('data-sig', sig);
    li.setAttribute('data-state', r.state);
    var badge = $('[data-rsfc-badge]', li), why = $('[data-rsfc-why]', li), shop = $('[data-rsfc-shop]', li);
    if (badge) badge.textContent = LABEL[r.state];
    if (why) why.textContent = r.text;
    if (shop) { shop.innerHTML = links ? '<span class="rsfc__shop-l">Shop matching parts</span>' + links : ''; shop.hidden = !links; }
  });
  var parts = [];
  if (n.ok) parts.push(n.ok + ' OK');
  if (n.warn) parts.push(n.warn + ' to check');
  if (n.bad) parts.push(n.bad + (n.bad > 1 ? ' problems' : ' problem'));
  if (n.info) parts.push(n.info + ' for info');
  this.summaryText = run ? run + ' of ' + total + ' checks run: ' + parts.join(', ') + '.' : '0 of ' + total + ' checks run. Fill in the fields to start.';
  if (this.summary && this.summary.textContent !== this.summaryText) this.summary.textContent = this.summaryText;
  if (announce) this.announce(this.summaryText + (problems.length ? ' Problem: ' + problems.slice(0, 3).join('; ') + (problems.length > 3 ? ' and ' + (problems.length - 3) + ' more' : '') + '.' : ''));
  return v;
};

/* Polite and debounced, so screen readers aren't flooded while someone types. */
Checker.prototype.announce = function (msg) {
  var self = this;
  clearTimeout(this.timer);
  this.timer = setTimeout(function () {
    if (msg === self.lastLive || !self.live) return;
    self.lastLive = self.live.textContent = msg;
  }, 900);
};

Checker.prototype.say = function (msg) {
  var s = this.status;
  if (!s) return;
  s.textContent = '';
  setTimeout(function () { s.textContent = msg; }, 50);
};

/* Plain-text summary of the build and the checks, for "Copy my build". */
Checker.prototype.text = function () {
  var self = this, v = this.render(false), out = ['FPV build check - Rising Sun FPV', String(window.location.href).split('#')[0], '', 'MY BUILD'];
  $$('[data-rsfc-field]', this.form).forEach(function (field) {
    var label = $('[data-rsfc-label]', field), sel = $('select', field), inp = $('input[type="text"]', field), value = '';
    var boxes = $$('input[type="checkbox"]:checked', field);
    if (sel && sel.value) value = sel.options[sel.selectedIndex].text;
    else if (inp && inp.value.trim() && !v.errors[inp.name]) value = inp.value.trim() + (inp.getAttribute('data-unit') ? ' ' + inp.getAttribute('data-unit') : '');
    else if (boxes.length) value = boxes.map(function (b) { return pat(b.value); }).join(', ');
    if (value && label) out.push('- ' + label.textContent.trim() + ': ' + value);
  });
  if (out.length === 4) out.push('- Nothing entered yet.');
  out.push('', 'CHECKS (' + this.summaryText + ')');
  Object.keys(CHECKS).forEach(function (id) {
    var r = self.results[id];
    if (r) out.push('[' + (r.state === 'idle' ? 'NOT RUN' : LABEL[r.state].toUpperCase()) + '] ' + self.title(id) + ': ' + r.text);
  });
  out.push('', "Rule-of-thumb guidance only. Check each part's specs before you buy.");
  return out.join('\n');
};

Checker.prototype.copy = function () {
  var self = this, text = this.text(), box = this.copybox;
  function done(ok) {
    if (ok || !box) {
      if (box) box.hidden = true;
      self.say(ok ? 'Copied. Paste it into a message, an email or a forum post.' : "Couldn't copy. Please try again.");
      return;
    }
    box.value = text;
    box.hidden = false;
    box.focus();
    box.select();
    self.say("Couldn't copy automatically. The summary is selected below, so copy it from there.");
  }
  function fallback() {
    var ta = d.createElement('textarea'), ok = false;
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.setAttribute('aria-hidden', 'true');
    ta.style.cssText = 'position:fixed;top:0;left:-9999px;opacity:0';
    d.body.appendChild(ta);
    ta.select();
    try { ok = d.execCommand('copy'); } catch (e) { ok = false; }
    d.body.removeChild(ta);
    return ok;
  }
  if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(text).then(function () { done(true); }, function () { done(fallback()); });
  else done(fallback());
};

Checker.prototype.reset = function () {
  this.form.reset();
  if (this.copybox) { this.copybox.hidden = true; this.copybox.value = ''; }
  this.showErrors(this.render(true));
  this.say('Cleared. All checks are waiting for parts again.');
};

Checker.prototype.init = function () {
  var self = this, copy = $('[data-rsfc-copy]', this.root), reset = $('[data-rsfc-reset]', this.root);
  this.form.addEventListener('submit', function (e) { e.preventDefault(); self.render(true); });
  this.form.addEventListener('input', function () { self.showErrors(self.render(true), true); });
  this.form.addEventListener('change', function () { self.showErrors(self.render(true)); });
  if (copy) copy.addEventListener('click', function () { self.copy(); });
  if (reset) reset.addEventListener('click', function () { self.reset(); });
  this.render(false);
};

/* ---- boot ---- */
function boot(scope) {
  $$('[data-rsfc]', scope || d).forEach(function (root) {
    if (root.getAttribute('data-rsfc-ready') || !$('[data-rsfc-form]', root)) return;
    root.setAttribute('data-rsfc-ready', '1');
    new Checker(root).init();
  });
}
if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { boot(); });
else boot();
d.addEventListener('shopify:section:load', function (e) { boot(e.target); });

/* Handy for testing rules in the browser console. */
window.RSFpvChecker = { CONFIG: CONFIG, parseStator: parseStator, evaluate: evaluate, findClass: findClass };
})();